import React from 'react'
import { Typography, CssBaseline, withStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { t as i18n } from 'ttag'
import IWLogo from '../assets/IntegraWatch-logo.svg'

const useStyles = makeStyles(theme => ({
  info: {
    width: '100%',
    maxWidth: 600,
    marginTop: theme.spacing(8)
  },
  desc: {
    width: '100%',
    maxWidth: 600,
    padding: theme.spacing(5, 0)
  },
  media: {
    height: '58px',
    padding: theme.spacing(1, 0),
    verticalAlign: 'middle',
    cursor: 'pointer'
  }
}))

const Headline = () => {
  const classes = useStyles()

  return (
    <div>
      <CssBaseline />
      <div className={classes.info}>
        <Typography variant='caption'>Powered by:</Typography>
      </div>
      <img className={classes.media} src={IWLogo} alt='IntegraWatch Home' />
      <Typography gutterBottom variant='body1' className={classes.desc}>
        IntegraWatch®
        {i18n`is a unified database with over 4,000,000 records of
        people, organisations and vessels that could present compliance or
        integrity risks to your company.`}
      </Typography>
    </div>
  )
}

export default Headline
